import {
	ConfiguredCarCatalogImage,
	ConfiguredCarFeatureFragment,
	ConfiguredCarPackageFragment,
	PriceFragment,
} from '~/graphql/__generated__/graphql';
import { CatalogItem } from '~/graphql/mapper/map-catalog';
import GetUrlFromImageSet, {
	GetMediaArrayFromImageSet,
	GetUrlArrayFromImageSet,
} from '~/graphql/utils/get-from-image-set';

export type AccessoriesItem = {
	imageUrl?: string | null;
	galleryImages: Array<string | undefined | null>;
	galleryMedia: Array<ConfiguredCarCatalogImage | null>;
	family: { id: string; name: string | null | undefined };
	group: { id: string; name: string | null | undefined };
} & CatalogItem &
	(ConfiguredCarFeatureFragment | ConfiguredCarPackageFragment);

export type Category = { id: string; label: string; items: AccessoriesItem[] };
export type GroupedAccessories = Map<string, Category>;

export type FixedAccessories = {
	features: {
		data: ConfiguredCarFeatureFragment[];
	};
	packagesDetails: {
		data?: ConfiguredCarPackageFragment[] | null;
	};
};

const mapAccessoryToCatalogItem = (
	item: ConfiguredCarFeatureFragment | ConfiguredCarPackageFragment,
	showPrices: boolean,
	showMonthlyRates: boolean,
): AccessoriesItem => {
	return {
		...item,
		name: item.name || '',
		imageUrl:
			GetUrlFromImageSet(item.imageSets, 'teaser_image') || GetUrlFromImageSet(item.imageSets, 'hd_thumbnail'),
		galleryImages: GetUrlArrayFromImageSet(item.imageSets, 'hd_image') || [''],
		galleryMedia: GetMediaArrayFromImageSet(item.imageSets, 'hd_image') || [],
		featureId: item.pr7,
		type: 'accessory',
		totalPrice: showPrices ? (item.price as PriceFragment) : undefined,
	};
};

export const extractCategories = (
	catalogItem: FixedAccessories,
	showPrices: boolean,
	showMonthlyRates: boolean,
	filterItems: (item: ConfiguredCarFeatureFragment | ConfiguredCarPackageFragment) => boolean = () => true,
) => {
	const accessoriesMap = new Map<string, Category>();

	[...catalogItem.features.data, ...(catalogItem.packagesDetails.data || [])]
		.filter(filterItems)
		.map((item) => mapAccessoryToCatalogItem(item, showPrices, showMonthlyRates))
		.forEach((item) => {
			const categoryItems = [...(accessoriesMap.get(item.group.id)?.items || []), item];
			accessoriesMap.set(item.group.id, { id: item.group.id, label: item.group.name, items: categoryItems });
		});
	return accessoriesMap;
};
